import React from 'react'

export default props => {
  let cn = `${props.className} ma0 st-mb3 norms-24 fw5` || 'ma0 st-mb3 norms-24 fw5'

  cn = props.marginSmall
    ? `${cn} st-mb3`
    : `${cn} st-mb4`

  return (
    <h3 className={cn}>{props.children}</h3>
  )
}
